(function(e) {
    // "use strict";
    function t(t) {
        var n = e(t)
          , a = e(":focus")
          , r = 0;
        if (1 === a.length) {
            var i = n.index(a);
            i + 1 < n.length && (r = i + 1)
        }
        n.eq(r).focus()
    }
    function n(t) {
        var z = e(t)
          , a = e(":focus")
          , r = z.length - 1;
        if (1 === a.length) {
            var i = z.index(a);
            i > 0 && (r = i - 1)
        }
        z.eq(r).focus()
    }
    function a(t) {
        function nn(t) {
            return e.expr.filters.visible(t) && !e(t).parents().addBack().filter(function() {
                return "hidden" === e.css(this, "visibility")
            }).length
        }
        var z, r, i, u = t.nodeName.toLowerCase(), o = !isNaN(e.attr(t, "tabindex"));
        return "area" === u ? (z = t.parentNode,
        r = z.name,
        t.href && r && "map" === z.nodeName.toLowerCase() ? (i = e("img[usemap=#" + r + "]")[0],
        !!i && nn(i)) : !1) : (/input|select|textarea|button|object/.test(u) ? !t.disabled : "a" === u ? t.href || o : o) && nn(t)
    }
    e.focusNext = function() {
        t(":focusable")
    }
    ,
    e.focusPrev = function() {
        n(":focusable")
    }
    ,
    e.tabNext = function() {
        t(":tabbable")
    }
    ,
    e.tabPrev = function() {
        n(":tabbable")
    }
    ,
    e.extend(e.expr[":"], {
        data: e.expr.createPseudo ? e.expr.createPseudo(function(t) {
            return function(n) {
                return !!e.data(n, t)
            }
        }) : function(t, n, a) {
            return !!e.data(t, a[3])
        }
        ,
        focusable: function(t) {
            return a(t, !isNaN(e.attr(t, "tabindex")))
        },
        tabbable: function(t) {
            var z = e.attr(t, "tabindex")
              , r = isNaN(z);
            return (r || z >= 0) && a(t, !r)
        }
    })
}(jQuery));
//
//
/* Obtiene la cookie de la sesion del usuario */
// function getCookie(name) {
//     var cookieValue = null;
//     if (document.cookie && document.cookie !== '') {
//         var cookies = document.cookie.split(';');
//         for (var i = 0; i < cookies.length; i++) {
//             var cookie = jQuery.trim(cookies[i]);
//             // Does this cookie string begin with the name we want?
//             if (cookie.substring(0, name.length + 1) === (name + '=')) {
//                 cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
//                 break;
//             }
//         }
//     }
//     return cookieValue;
// }

$(document).ready(function(){
    function csrfSafeMethod(method) {
        // these HTTP methods do not require CSRF protection
        return (/^(GET|HEAD|OPTIONS|TRACE)$/.test(method));
    }

    $.ajaxSetup({
        beforeSend: function(xhr, settings) {
            var csrftoken = $.cookie('csrftoken');
            if (!csrfSafeMethod(settings.type) && !this.crossDomain) {
                xhr.setRequestHeader("X-CSRFToken", csrftoken);
            }
        },
        cache: true
    });
});


(function() {
    // // SET HAPROXY COOKIE FOR TEST SERVER
    // if (VAR_USER_DB === 1) {
    //     $.cookie('SERVERID', 'A', {path: '/'});
    // } else {
    //     $.cookie('SERVERID', 'B', {path: '/'});
    // }

    // SELECTOR FOR COMPANY IN SESSION
    var $form_get_company = $('#form_get_company');

    function change_company() {
        // set company_id in session storage for keep company session between companies
        window.set_company_id($form_get_company.find('#id_company_selector').val());
        var form = $form_get_company.serialize();
        $.ajax({
            url: $form_get_company.find('[name=url]').val(),
            context: document.body,
            data: form,
            method: 'GET'
        }).done(function(response) {
            if (response === 'success'){
                location.reload();
            }
        });
    }

    $form_get_company.find('#id_company_selector').on('select2:select', function() {
        change_company();
    }).on('addDjRelated', function () {
        change_company();
    });

    $(window).on('load', function () {
        /* Disable tabindex to anchors */
        setTimeout(function () {
            $('a').each(function () {
                $(this).attr('tabindex', '-1');
            });
        }, 200);
    });


    // CONVERT ENTER IN TAB FOR FORMS
    $('.form-horizontal').on('keydown', 'input:not(input[type=submit])', function (e) {
        var keyCode = e.keyCode || e.which;
        if (keyCode === 13) {
            e.preventDefault();
            // JQuery don't dispatch key events from same element

            jQuery.tabNext();
        }
    });

    // ADD SPINNER LOADING WHEN CLICK ON LINKS
    $(document).on('click', 'a', function(event){
        var element = $(this);
        var att_class = element.attr('class') || '';
        var href = element.attr('href');
        if (href && href.substring(0,1) !== '#' &&
            !href.startsWith('javascript:') &&
            element.attr('target') !== '_blank' &&
            href.toLowerCase().indexOf("_popup") === -1 &&
            att_class.indexOf('related-widget-wrapper-link') === -1 &&
            att_class.indexOf('not-loading') === -1
        ) {
            window.set_load_spinner(element);
        }
    });

    window.set_load_spinner = function($ele){
        $ele.append('<span class="glyphicon glyphicon-refresh glyphicon-refresh-animate"></span>');
    };

    window.remove_load_spinner = function($ele){
        $ele.find('.glyphicon-refresh-animate').remove();
    };

    $(document).on('click', '.loading-icon-onclick', function () {
        $(this).addClass('disabled')
            .append(' <span class="glyphicon glyphicon-refresh glyphicon-refresh-animate"></span>');
    });

    // $('.loading-icon-click').click(function(){
    //     var $this = $(this);
    //     $this.append(' <span class="glyphicon glyphicon-refresh glyphicon-refresh-animate"></span>');
    // });

    // ADD A CLASS FOR TIME MESSAGE
    $.fn.extend({
        addTemporaryClass: function (className, duration) {
            var elements = this;
            setTimeout(function () {
                elements.removeClass(className);
            }, duration);

            return this.each(function () {
                $(this).addClass(className);
            });
        }
    });

    //$('[title]').tooltip();

 })();